import { render } from "./expressAccount.vue?vue&type=template&id=21a67742&scoped=true"
import script from "./expressAccount.vue?vue&type=script&lang=js"
export * from "./expressAccount.vue?vue&type=script&lang=js"

import "./expressAccount.vue?vue&type=style&index=0&id=21a67742&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a67742"]])

export default __exports__